import { AssistantRuntimeProvider, useExternalStoreRuntime } from "@assistant-ui/react";
import React from "react";

/**
 * Bridge between our AI SDK `useChat` wiring (transport, SSE, session
 * persistence — unchanged) and the assistant-ui runtime the adopted UI
 * components read from.
 *
 * This is the seam that keeps Path 1 intact: assistant-ui replaces the chat
 * *components*; `useChat` keeps owning the wire protocol. Everything below
 * this provider consumes messages/state from the runtime, never from props.
 */
export const AiChatRuntime = ({ messages, isRunning, onNew, onCancel, convertMessage, children }) => {
    const runtime = useExternalStoreRuntime({
        messages,
        isRunning,
        onNew,
        onCancel,
        convertMessage
    });

    return <AssistantRuntimeProvider runtime={runtime}>{children}</AssistantRuntimeProvider>;
};
